import { createApp } from "vue";
import App from "./App.vue";
import 'normalize.css'
import '@/assets/css/main.css'


createApp(App).mount("#app");
